import { Instance, types } from 'mobx-state-tree';

export const CategoryModel = types.model('CategoryModel', {
  id: types.identifier,
  name: types.string,
  icon: types.maybe(types.string),
});

export type CategoryModelType = Instance<typeof CategoryModel>;
